import React from 'react';

type DebugPanelProps = {
  playerId: string;
  lastUpdated: string | undefined;
  pollInterval: number;
  setPollInterval: (n: number) => void;
};

const DebugPanel: React.FC<DebugPanelProps> = ({ playerId, lastUpdated, pollInterval, setPollInterval }) => (
  <div id="debugPanel" className="panel debug-panel">
    <h3 className="panel-title">Debug Information</h3>
    <div className="debug-item">
      <span className="debug-label">Player ID:</span> 
      <span className="debug-value">{playerId}</span>
    </div>
    <div className="debug-item">
      <span className="debug-label">Last Updated:</span> 
      <span className="debug-value">{lastUpdated || '-'}</span>
    </div>
    <div className="debug-item">
      <span className="debug-label">Poll Interval:</span>
      <select 
        className="select-control"
        value={pollInterval / 1000} 
        onChange={e => setPollInterval(Number(e.target.value) * 1000)}
      >
        <option value={1}>1s</option>
        <option value={5}>5s</option>
        <option value={30}>30s</option>
      </select>
      <span className="debug-note">(auto-refresh)</span>
    </div>
  </div>
);

export default DebugPanel;